import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Testimonial from "../components/Testimonial";

const Home = () => {
  return (
    <main>
      <Hero />
      <Services />
      <Testimonial />
    </main>
  );
};

export default Home;
